import React from "react";
import { useSearchParams } from "react-router-dom";
import type { MeetingLayout } from "../../types";

import { useGetMeetingAttendance } from "../../store";
import MeetingPage from "./meeting-page";
import MeetingErrorPanel from "./components/meeting-error-panel";
import MeetingLoadingPage from "./meeting-loading-page";

const MeetingRouterPage: React.FC = () => {
  const [searchParams] = useSearchParams();

  const meetingId = searchParams.get("meetingId") || "";
  const userId = searchParams.get("userId") || "";
  const joinCode = searchParams.get("joinCode") || "";
  const via = searchParams.get("via") || "";
  const layout = searchParams.get("layout") || "";

  const {
    data: attendanceInfo = null,
    isLoading,
    isError,
  } = useGetMeetingAttendance(meetingId || "", userId, joinCode);

  return isLoading ? (
    <MeetingLoadingPage />
  ) : isError ? (
    <MeetingErrorPanel message="An error occurred while fetching meeting attendance information." />
  ) : attendanceInfo ? (
    attendanceInfo.meetingType === "Ended" ? (
      <MeetingErrorPanel message="The meeting has already ended." />
    ) : attendanceInfo.meetingType === "Cancelled" ? (
      <MeetingErrorPanel message="The meeting has been cancelled." />
    ) : attendanceInfo.meetingType === "Abandoned" ? (
      <MeetingErrorPanel message="The meeting was abandoned." />
    ) : (
      <MeetingPage
        meetingId={meetingId}
        userId={userId}
        joinCode={joinCode}
        viaQRCode={via === "qr"}
        layout={layout.length > 0 ? (layout as MeetingLayout) : undefined}
      />
    ) 
  ) : (
    <MeetingErrorPanel message="Meeting information is not available." />
  )
};

export default MeetingRouterPage;
